import { createSystem, defaultConfig } from "@chakra-ui/react";
import { buttonRecipe } from "./theme/button.recipe";

export const system = createSystem(defaultConfig, {
  globalCss: {
    html: {
      fontSize: "14px",
      fontFamily: `'Noto Sans KR', sans-serif`,
      lineHeight: 1.6,
    },
    body: {
      fontFamily: `'Noto Sans KR', sans-serif`,
      fontSize: "0.875rem",
      margin: 0,
      padding: 0,
    },
    // scrollbar
    ".main-link": {
      color: "ui.main",
      fontWeight: "bold",
    },
    '::-webkit-scrollbar': {
        width: '6px',
      },
      '::-webkit-scrollbar-thumb': {
        backgroundColor: '#a0aec0',
        borderRadius: '10px',
      },
      '::-webkit-scrollbar-track': {
        backgroundColor: '#f7fafc',
      },
      '*': {
        scrollbarWidth: 'thin',
        scrollbarColor: '#a0aec0 #f7fafc',
      },
  },
  theme: {
    tokens: {
      colors: {
        ui: {
          main: { value: "#009688" },
        },
        brand: {
          primary: { value: "#007BFF" },
          secondary: { value: "#6C757D" },
          tertiary: { value: "#17A2B8" },
          accent: { value: "#FFC107" },
        },
      },
    },
    semanticTokens: {
      colors: {
        bg: {
          option1: {
            value: { _light: "#F7F8FA", _dark: "#23283D" },
          },
          option2: {
            value: { _light: "#FFFFFF", _dark: "#141828" },
          },
        },
        borders: {
          muted: {
            value: {
              _light: "rgba(102,111,141,0.1)",
              _dark: "rgba(102,111,141,0.2)",
            },
          },
        },
      },
    },
    recipes: {
      button: buttonRecipe,
    },
  },
});
